// Digital Shelf — base theme script

document.addEventListener('DOMContentLoaded', function () {
  // Product page: swap main image on thumbnail click
  var thumbs = document.querySelectorAll('.product-thumbs img');
  var mainImage = document.querySelector('.product-media > img');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) {
        mainImage.src = thumb.src.replace(/width=\d+/, 'width=900');
      }
    });
  });
});
